import React, { useState } from 'react';
import Navbar from '../navbar';
import TopNavbar from '../topnavbar';
import Footer from '../footer';
import '../../App.css';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { sendEmail } from '../globalFunctions';

function PagIbigLandbankCard() {

  const EmployeeId = sessionStorage.getItem("employeeId");

  const [thisInfo, setThisInfo] = useState({
    Application_Form: '',
    paySlipFiles: '',
    paySlip2Files: '',
    Valid_ID: '',
    Selfie_ID: ''
  });

  // useEffect(() => {
  //   [EmployeeId]
  // });

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const isValidFileType = (file) => {
        const allowedTypes = ['application/pdf', 'image/png', 'image/jpeg'];
        return file && allowedTypes.includes(file.type);
    };

    const formData = new FormData();
    formData.append('currentEmployeeId', EmployeeId);

    // Validate and append Application Form
    if (isValidFileType(thisInfo.Application_Form)) {
        formData.append('Application_Form', thisInfo.Application_Form);

        document.getElementById('appFormInvalid').style.border = '';
        document.getElementById('PayslipInvalid').style.border = '';
        document.getElementById('IdInvalid').style.border = '';
    } else {
      document.getElementById('appFormInvalid').style.border = '1px solid red';
      document.getElementById('PayslipInvalid').style.border = '';
      document.getElementById('IdInvalid').style.border = '';
      toast.error('Invalid file type. Please check your file you uploaded.', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
        return; // Stop further execution
    }

    // Validate and append Pay Slip Files
    if (isValidFileType(thisInfo.paySlipFiles)) {
        formData.append('paySlipFiles', thisInfo.paySlipFiles);

        document.getElementById('appFormInvalid').style.border = '';
        document.getElementById('PayslipInvalid').style.border = '';
        document.getElementById('IdInvalid').style.border = '';
    } else {
        document.getElementById('appFormInvalid').style.border = '';
        document.getElementById('PayslipInvalid').style.border = '1px solid red';
        document.getElementById('IdInvalid').style.border = '';
        toast.error('Invalid file type. Please check your file you uploaded.', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
        return; // Stop further execution
    }

    // Validate and append Pay Slip Files
    if (isValidFileType(thisInfo.paySlip2Files)) {
        formData.append('paySlip2Files', thisInfo.paySlip2Files);

        document.getElementById('appFormInvalid').style.border = '';
        document.getElementById('Payslip2Invalid').style.border = '';
        document.getElementById('IdInvalid').style.border = '';
    } else {
        document.getElementById('appFormInvalid').style.border = '';
        document.getElementById('Payslip2Invalid').style.border = '1px solid red';
        document.getElementById('IdInvalid').style.border = '';
        toast.error('Invalid file type. Please check your file you uploaded.', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
        return; // Stop further execution
    }


    // Validate and append Valid ID
    if (isValidFileType(thisInfo.Valid_ID)) {
        formData.append('Valid_ID', thisInfo.Valid_ID);

        document.getElementById('appFormInvalid').style.border = '';
        document.getElementById('PayslipInvalid').style.border = '';
        document.getElementById('IdInvalid').style.border = '';
    } else {
      document.getElementById('appFormInvalid').style.border = '';
      document.getElementById('PayslipInvalid').style.border = '';
      document.getElementById('validIdInput').style.border = '1px solid red';
      toast.error('Invalid file type. Please check your file you uploaded.', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
        return; // Stop further execution
    }

    // Validate and append Valid ID
    if (isValidFileType(thisInfo.Selfie_ID)) {
        formData.append('Selfie_ID', thisInfo.Selfie_ID);
        document.getElementById('appFormInvalid').style.border = '';
        document.getElementById('PayslipInvalid').style.border = '';
        document.getElementById('SelfieIdInvalid').style.border = '';
    } else {
      document.getElementById('appFormInvalid').style.border = '';
      document.getElementById('PayslipInvalid').style.border = '';
      document.getElementById('SelfieIdInvalid').style.border = '1px solid red';
      toast.error('Invalid file type. Please check your file you uploaded.', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
        return; // Stop further execution
    }

    try {
        const response = await fetch('/api/PagIbigLandbankCard', {
            method: 'POST',
            body: formData,
        });

        if (response.ok) {
            const jsonResponse = await response.json();

            console.log(jsonResponse.message);

            setThisInfo({
                Application_Form: '',
                paySlipFiles: '',
                Valid_ID: '',
                Selfie_ID: ''
            });

            // Clear file input fields
            document.getElementById('applicationFormInput').value = null;
            document.getElementById('paySlipInput').value = null;
            document.getElementById('paySlipInput2').value = null;
            document.getElementById('validIdInput').value = null;
            document.getElementById('selfieIdInput').value = null;

            sendEmailNotification()

            // Emit success toast
            toast.success('Thank you! Your request has been submitted.', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

        }  else {
          console.error('Failed to submit request:', response.statusText);
          toast.error('Failed to Submit', {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
          });
      }
  } catch (error) {
      console.error('Error uploading:', error);
  }
};

  const handleApplication_Form = (e) => {
    setThisInfo({ ...thisInfo, Application_Form: e.target.files[0] });
  };
  const handlepay_Slip = (e) => {
    setThisInfo({ ...thisInfo, paySlipFiles: e.target.files[0] });
  };
  
  const handlePay_Slip_2 = (e) => {
    setThisInfo({ ...thisInfo, paySlip2Files: e.target.files[0] });
  };

  const handleValid_ID = (e) => {
    setThisInfo({ ...thisInfo, Valid_ID: e.target.files[0] });
  };

  const handleSelfie_ID = (e) => {
    setThisInfo({ ...thisInfo, Selfie_ID: e.target.files[0] });
  };

  
  const sendEmailNotification= () => {
        
    const content = {
        HrName: '',
        HrEmail: '', // hr's email
        Name: sessionStorage.getItem("firstName") + " " + sessionStorage.getItem("lastName"),
        EmailAddress: sessionStorage.getItem("email"), // employee's email
        TransactionType: 'Pag-Ibig Landbank Card',
        documentName: '',
        reason: '',
        stopDeduction: false,
        facility: sessionStorage.getItem("facility")
    };

    
    
    sendEmail('submit',content)
  };
  

  return (
    <div id="wrapper">
      <Navbar />
      <div id="content-wrapper" className="d-flex flex-column">
        <div id="content">
          <TopNavbar />
          <div className="container-fluid">
            <div className="row justify-content-center">
              <h4 className="m-0 font-weight-bold text-primary header-name"> Pag-IBIG Loan Without Loyalty Card Plus</h4>
            </div>
          </div>
          <form onSubmit={handleFormSubmit}>
            {/* page content begin here */}
            <div className="container-fluid">
              <div className="row justify-content-center">
                <div className="col-xl-8 col-lg-7">
                  <div className="card shadow mb-4">
                    {/* Card Header - New Hire Upload */}
                    <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                      <h6 className="m-0 font-weight-bold text-primary">Application Form</h6>
                    </div>
                    {/* Card Body - New Hire Options */}
                    <div className="card-body" id='appFormInvalid'>
                      <div className="tab-content">
                        <div className="card-body">
                          <div className="d-flex justify-content-left">
                            <input id="applicationFormInput" type="file" className="input-file" aria-describedby="fileHelp" onChange={handleApplication_Form} />
                            
                          </div>
                          {/* Guide Link */}
                          <div className="text-end mt-3">
                              <a
                                  href="https://innodata.sharepoint.com/:f:/s/HR-TOOLS/El4_97jbyQNJiglPSFvBxwIBCP9EsXH6f5C_nK1v9NL2Dw?e=QwuHCe"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ fontSize: '12px', textDecoration: 'underline', color: '#007bff' }}
                              >
                                  How to apply for PAG-IBIG Loan via Virtual Account?
                              </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Page content ends here */}

            {/* page content begin here */}
            <div className="container-fluid">
              <div className="row justify-content-center">
                <div className="col-xl-8 col-lg-7">
                  <div className="card shadow mb-4">
                    {/* Card Header - New Hire Upload */}
                    <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                      <h6 className="m-0 font-weight-bold text-primary">1st Cut-Off Pay Slip</h6>
                    </div>
                    {/* Card Body - New Hire Options */}
                    <div className="card-body" id='PayslipInvalid'>
                      <div className="tab-content">
                        <div className="card-body">
                          <div className="d-flex justify-content-left">
                            <input id="paySlipInput" type="file" className="input-file" aria-describedby="fileHelp" onChange={handlepay_Slip} />
                            
                          </div>
                           {/* Guide Link */}
                          <div className="text-end mt-3">
                              <a
                                  href="https://innodataiksi.stohrm.com"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ fontSize: '12px', textDecoration: 'underline', color: '#007bff' }}
                              >
                                  Link to download payslip.
                              </a>
                          </div>
                          <br/>
                          <label style={{ fontSize: '12px'}}><b>Reminder:</b> Please ensure that you submit the unedited/original copy of your payslip. 
                          Do not alter, crop, or modify the file in any way before submission. Edited files may result in delays or rejection of your submission.</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Page content ends here */}

            {/* page content begin here */}
            <div className="container-fluid">
              <div className="row justify-content-center">
                <div className="col-xl-8 col-lg-7">
                  <div className="card shadow mb-4">
                    {/* Card Header - New Hire Upload */}
                    <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                      <h6 className="m-0 font-weight-bold text-primary">2nd Cut-Off Pay Slip</h6>
                    </div>
                    {/* Card Body - New Hire Options */}
                    <div className="card-body" id='Payslip2Invalid'>
                      <div className="tab-content">
                        <div className="card-body">
                          <div className="d-flex justify-content-left">
                            <input id="paySlipInput2" type="file" className="input-file" aria-describedby="fileHelp" onChange={handlePay_Slip_2} />
                            
                          </div>
                          
                           {/* Guide Link */}
                          <div className="text-end mt-3">
                              <a
                                  href="https://innodataiksi.stohrm.com"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ fontSize: '12px', textDecoration: 'underline', color: '#007bff' }}
                              >
                                  Link to download payslip.
                              </a>
                          </div>
                          
                            <br/>
                            <label style={{ fontSize: '12px'}}><b>Reminder:</b> Please ensure that you submit the unedited/original copy of your payslip. 
                            Do not alter, crop, or modify the file in any way before submission. Edited files may result in delays or rejection of your submission.</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Page content ends here */}

            {/* page content begin here */}
            <div className="container-fluid">
              <div className="row justify-content-center">
                <div className="col-xl-8 col-lg-7">
                  <div className="card shadow mb-4">
                    {/* Card Header - New Hire Upload */}
                    <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                      <h6 className="m-0 font-weight-bold text-primary">One(1) Valid ID, Innodata Company ID, or Cash Card</h6>
                    </div>
                    {/* Card Body - New Hire Options */}
                    <div className="card-body" id='IdInvalid'>
                      <div className="tab-content">
                        <div className="card-body">
                          <div className="d-flex justify-content-left">
                            <input id="validIdInput" type="file" className="input-file" aria-describedby="fileHelp" onChange={handleValid_ID} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Page content ends here */}

             {/* page content begin here */}
            <div className="container-fluid">
              <div className="row justify-content-center">
                <div className="col-xl-8 col-lg-7">
                  <div className="card shadow mb-4">
                    {/* Card Header - New Hire Upload */}
                    <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                      <h6 className="m-0 font-weight-bold text-primary">Selfie Photo with Valid ID & Loyalty Card</h6>
                    </div>
                    {/* Card Body - New Hire Options */}
                    <div className="card-body" id='SelfieIdInvalid'>
                      <div className="tab-content">
                        <div className="card-body">
                          <div className="d-flex justify-content-left">
                            <input id="selfieIdInput" type="file" className="input-file" aria-describedby="selfiefileHelp" onChange={handleSelfie_ID} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Page content ends here */}

            <label style={{ fontSize: '12px', marginLeft: '310px', width: '100%'}}>Note: File upload only accepts PDF, PNG, or JPEG file.</label>
            <button type="submit" className="btn btn-primary d-block mx-auto loan-btn">Submit</button>
          </form>
        </div>
        <Footer />
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default PagIbigLandbankCard;